import { CartIcon } from './cart_icon';

export default CartIcon;
